import HeroCarousel from './components/HeroCarousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from './components/scrollable';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';
import { trackEvent, trackLink } from '@99designs/common/utils/platform';
import LogoDesignInspiration from './components/LogoDesignInspiration';
import SlideCarousel from './components/slide-carousel';
import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    const scrollToLinks = document.querySelectorAll('[data-hero-scrollto-link]');

    for (var i = 0; i < scrollToLinks.length; i++) {
        new ScrollToElement(scrollToLinks[i]).handleClick();
    }

    new LogoDesignInspiration();
});

document.addEventListener('DOMContentLoaded', () => {
    const productCTA = document.querySelectorAll('[data-product-cta]');

    Array.from(productCTA).forEach(element => {
        trackLink(element, 'Clicked CTA on Product page', {
            cta_location: element.getAttribute('data-product-cta-location'),
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Track FAQ usage to Segment
    const accordionTriggers = document.querySelectorAll('#faqs [data-accordion-item-trigger]');

    for (var i = 0; i < accordionTriggers.length; i++) {
        const trigger = accordionTriggers[i];

        trigger.addEventListener('click', e =>
            trackEvent('Clicked FAQ on Product Page', {
                title: trigger.textContent.trim(),
            })
        );
    }

    // Product features
    createProductFeatures();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // horizontally scrollable elements
    createScrollableElements();

    // Example designs
    scrollOnHover('[data-scrollable="examples"]');
    centerAlignScrollableElement('[data-scrollable="examples"]').then(el => {
        const designCards = document.querySelectorAll('[data-design-card]');

        for (var i = 0; i < designCards.length; i++) {
            designCards[i].style.visibility = 'visible';
        }
    });

    // Contest listings
    scrollOnHover('[data-scrollable="contests"]');
    centerAlignScrollableElement('[data-scrollable="contests"]');

    centerAlignScrollableElement('[data-scrollable="options"]');
    scrollOnHover('[data-scrollable="options"]');

    // Hero carousel
    HeroCarousel.create().start();

    // FAQs
    Accordion.create();
});

// Initialise design galleries
document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('[data-slide-carousel]');

    Array.from(galleries).forEach(
        gallery =>
            new SlideCarousel({
                element: gallery,
                stepElement: gallery.querySelector('[data-carousel-steps]'),
                stepClickEventMessage: 'Clicked Gallery Control On Designer List',
            })
    );
});

document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('[data-designer-list-selection-item]');
    const details = document.querySelectorAll('[data-designer-list-details-item]');

    Array.from(items).forEach(item => {
        const index = item.getAttribute('data-designer-list-selection-item');

        item.addEventListener('click', e => {
            e.preventDefault();

            // Clear active state from all detail items
            Array.from(details).forEach(d => d.removeAttribute('data-active'));

            // Clear active state from all selection items
            Array.from(items).forEach(d => d.removeAttribute('data-active'));

            // Set active state on requested detail item
            document
                .querySelector(`[data-designer-list-details-item="${index}"]`)
                .setAttribute('data-active', true);

            // Set active state on requested seletion item
            document
                .querySelector(`[data-designer-list-selection-item="${index}"]`)
                .setAttribute('data-active', true);

            trackEvent('Clicked Designer On Designer List Item', {
                designer_list_item_index: index,
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // horizontally scrollable elements
    createScrollableElements();

    centerAlignScrollableElement('[data-scrollable="designer-list"]');
    scrollOnHover('[data-scrollable="designer-list"]');
});

document.addEventListener('DOMContentLoaded', () => {
    const designerListCTA = document.querySelectorAll('[data-designer-list-cta]');

    Array.from(designerListCTA).forEach(element => {
        trackLink(element, 'Clicked CTA On Designer List', {
            cta_location: element.getAttribute('data-designer-list-cta-location'),
        });
    });
});

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('Product Page');
});



// WEBPACK FOOTER //
// ./js/marketing/product.js